module.exports = __webpack_public_path__ + "img/1515270344.fce2ed70.jpg";